<template>
  <div class="position">
    <p>{{ pageName }}</p>
    <div class="location">
      <div v-for="(item, index) in path" :key="index" style="float: left">
        <a :href="item.url">{{ item.name }}</a><span v-if="index + 1 < path.length"> > </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CrambHeader',
  props: {
    pageName: {
      type: String,
      default: 'Home'
    },
    path:
      {
        type: Array,
        default: () => [
          {
            name: 'Home',
            url: 'http://www.dengjunclub.com/'
          },
          {
            name: 'xxxx',
            url: 'http://www.dengjunclub.com/'
          },
          {
            name: 'xxxx',
            url: 'http://www.dengjunclub.com/'
          }
        ]
      }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/public/CrambHeader.vue